import news_empty_img from "../../assets/ac72f2849ccd0d5c.png";
import news_empty_img_for_user from "../../assets/5546f4ca973838d7.png";
import checkBoxFalseState from "../../assets/af3e81b14d16a108.svg";
import checkBoxTrueState from "../../assets/db965a944bda19e8.svg";
import checkBoxIndeterminateState from "../../assets/946d56e054daa43e.svg";
import accessDenied from "../../assets/96a531c172eb3a76.svg";
import tableNoData from "../../assets/f67279aeb9137d03.svg";
import pages_empty from "../../assets/5a0af7dd23957928.png";
const BanzaImgPresets = {
  BanzaImg: {
    presets: {
      AccessDenied: {
        attrs: {
          src: accessDenied
        }
      },
      TableNoData: {
        attrs: {
          src: tableNoData
        }
      },
      NewsEmptyImg: {
        attrs: {
          src: news_empty_img
        }
      },
      NewsEmptyImgForUser: {
        attrs: {
          src: news_empty_img_for_user
        }
      },
      PagesEmptyImg: {
        attrs: {
          src: pages_empty
        }
      },
      CheckBoxFalseState: {
        attrs: {
          src: checkBoxFalseState
        }
      },
      CheckBoxTrueState: {
        attrs: {
          src: checkBoxTrueState
        }
      },
      CheckBoxIndeterminateState: {
        attrs: {
          src: checkBoxIndeterminateState
        }
      }
    }
  }
};
export {
  BanzaImgPresets as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
